/* Elegance Coque — panier latéral + « Acheter maintenant ».
   ECBuy.open()            : ouvre le panier latéral (articles, variantes, quantités, suppression, total).
   ECBuy.buyNow(v, qty, u) : formulaire de commande paiement à la livraison (appli EasySell) ;
                             interrupteur « Appli de commande à la livraison installée » de la section
                             « Parcours d'achat » (+ détection du script de l'appli) ; sinon paiement Shopify direct.
   Livraison affichée : offerte dès que le panier contient une coque (types « Types de produit qui offrent
   la livraison ») ; accessoires seuls = frais fixes (35 DH). Paramètres › Expédition doit appliquer la même règle. */
(function () {
  if (window.ECBuy) { return; }
  var d = document, W = window;
  var ROOT = (W.Shopify && W.Shopify.routes && W.Shopify.routes.root) || '/';
  var CFG = {};
  try { CFG = JSON.parse((d.getElementById('ec-parcours-config') || {}).textContent || '{}'); } catch (e) {}
  var FREE = String(CFG.free_types || CFG.coque_type || 'Coque iPhone, Pack').split(',')
    .map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
  var FEE = Math.round((Number(CFG.ship_fee) || 35) * 100);
  /* boutons d'ouverture du formulaire COD : « es-popup-button-overwrite » = classe documentée par EasySell */
  var COD_SEL = '.es-popup-button-overwrite,[data-ec-cod-trigger],.es-form-hook button,.es-form-button,.es-buy-button,#es-form-button,button[class*="easysell"],button[class*="es-buy"]';

  function esc(t) { var s = d.createElement('span'); s.textContent = t == null ? '' : String(t); return s.innerHTML; }
  function dh(c) { c = Math.round(Number(c) || 0); var w = Math.floor(c / 100), r = c % 100; return String(w).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + (r ? ',' + (r < 10 ? '0' : '') + r : '') + ' DH'; }
  function img(u, w) { if (!u) { return ''; } u = u.indexOf('//') === 0 ? 'https:' + u : u; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 160); }
  function isFree(it) { return FREE.indexOf(String(it.product_type || '').trim().toLowerCase()) > -1; }
  function shipping(cart) {
    if (!cart || !cart.item_count) { return 0; }
    return cart.items.some(isFree) ? 0 : FEE;
  }
  function json(url, body) {
    return fetch(ROOT + url, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) { throw new Error(j.description || j.message || 'Erreur'); } return j; }); });
  }

  var ICON_X = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg>';
  var ICON_BIN = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13"/></svg>';

  /* ---------- panier latéral ---------- */
  var root, list, foot, title, lastFocus, busy = false, cart = null;

  function build() {
    root = d.createElement('div');
    root.className = 'ecd';
    root.hidden = true;
    root.innerHTML =
      '<div class="ecd__ov" data-ecd-close></div>' +
      '<aside class="ecd__panel" role="dialog" aria-modal="true" aria-labelledby="ecd-t">' +
        '<header class="ecd__hd"><p class="ecd__t" id="ecd-t">Mon panier</p>' +
        '<button type="button" class="ecd__x" data-ecd-close aria-label="Fermer le panier">' + ICON_X + '</button></header>' +
        '<p class="ecd__ok" data-ecd-ok hidden>Produit ajouté au panier ✓</p>' +
        '<div class="ecd__list" data-ecd-list aria-live="polite"></div>' +
        '<footer class="ecd__ft" data-ecd-foot></footer>' +
      '</aside>';
    d.body.appendChild(root);
    list = root.querySelector('[data-ecd-list]');
    foot = root.querySelector('[data-ecd-foot]');
    title = root.querySelector('#ecd-t');
    root.addEventListener('click', onClick);
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root && !root.hidden) { close(); } });
  }

  function lineHtml(it, i) {
    var opts = [];
    if (it.variant_title && !it.product_has_only_default_variant) { opts.push(esc(it.variant_title)); }
    var props = it.properties || {};
    Object.keys(props).forEach(function (k) { if (props[k] && k.charAt(0) !== '_') { opts.push(esc(k) + ' : ' + esc(props[k])); } });
    var line = i + 1;
    return '<div class="ecd__it" data-line="' + line + '">' +
      '<a class="ecd__img" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(img(it.image)) + '" alt="" loading="lazy" width="72" height="90">' : '') + '</a>' +
      '<div class="ecd__info">' +
        '<a class="ecd__name" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
        (opts.length ? '<p class="ecd__var">' + opts.join('<br>') + '</p>' : '') +
        '<p class="ecd__pr">' + dh(it.final_price) + '</p>' +
        '<div class="ecd__row">' +
          '<div class="ecd__qty" role="group" aria-label="Quantité">' +
            '<button type="button" data-ecd-q="' + (it.quantity - 1) + '" aria-label="Retirer un">−</button>' +
            '<span aria-live="polite">' + it.quantity + '</span>' +
            '<button type="button" data-ecd-q="' + (it.quantity + 1) + '" aria-label="Ajouter un">+</button>' +
          '</div>' +
          '<button type="button" class="ecd__rm" data-ecd-q="0" aria-label="Supprimer ' + esc(it.product_title) + '">' + ICON_BIN + '<span>Supprimer</span></button>' +
        '</div>' +
      '</div>' +
      '<p class="ecd__lt">' + dh(it.final_line_price) + '</p>' +
    '</div>';
  }

  function render() {
    if (!root) { return; }
    var n = cart ? cart.item_count : 0;
    title.textContent = 'Mon panier' + (n ? ' (' + n + ')' : '');
    if (!n) {
      list.innerHTML = '<div class="ecd__empty"><p>Votre panier est vide.</p></div>';
      foot.innerHTML = '<button type="button" class="ecd__cont" data-ecd-close>Continuer mes achats</button>';
      return;
    }
    list.innerHTML = cart.items.map(lineHtml).join('');
    var ship = shipping(cart);
    foot.innerHTML =
      '<dl class="ecd__sum">' +
        '<div><dt>Sous-total</dt><dd>' + dh(cart.total_price) + '</dd></div>' +
        '<div><dt>Livraison</dt><dd>' + (ship ? dh(ship) : '<b class="ecd__free">Offerte</b>') + '</dd></div>' +
        '<div class="ecd__tot"><dt>Total</dt><dd>' + dh(cart.total_price + ship) + '</dd></div>' +
      '</dl>' +
      '<p class="ecd__note">Paiement à la livraison · Livraison 24–48 h partout au Maroc</p>' +
      '<a class="ecd__go" href="' + ROOT + 'checkout" data-ecd-go>Passer commande</a>' +
      '<button type="button" class="ecd__cont" data-ecd-close>Continuer mes achats</button>' +
      '<a class="ecd__cart" href="' + ROOT + 'cart">Voir mon panier</a>';
  }

  function load() {
    return json('cart.js').then(function (c) { cart = c; render(); return c; });
  }

  function change(line, qty) {
    if (busy) { return; }
    busy = true;
    root.classList.add('is-busy');
    json('cart/change.js', { line: line, quantity: Math.max(0, qty) })
      .then(function (c) { cart = c; render(); try { d.dispatchEvent(new CustomEvent('lt:cart-changed')); } catch (e) {} })
      .catch(function (err) { W.alert((err && err.message) || 'La modification n’a pas abouti. Veuillez réessayer.'); return load(); })
      .then(function () { busy = false; root.classList.remove('is-busy'); });
  }

  function onClick(e) {
    var t = e.target;
    if (t.closest('[data-ecd-close]')) { e.preventDefault(); close(); return; }
    /* 30-10 : « Passer commande » ouvre le formulaire paiement à la livraison (EasySell) du panier, pas le paiement Shopify */
    if (t.closest('[data-ecd-go]') && W.__ecCodApp && typeof W.openTysloForm === 'function') {
      e.preventDefault(); close();
      setTimeout(function () { try { W.openTysloForm(true); } catch (err) { location.href = ROOT + 'checkout'; } }, 280);
      return;
    }
    var q = t.closest('[data-ecd-q]');
    if (q) { var it = q.closest('[data-line]'); change(Number(it.getAttribute('data-line')), Number(q.getAttribute('data-ecd-q'))); }
  }

  function open(added) {
    if (!root) { build(); }
    if (root.hidden) { lastFocus = d.activeElement; }
    root.querySelector('[data-ecd-ok]').hidden = !added;
    if (!cart) { list.innerHTML = '<p class="ecd__load">Chargement…</p>'; foot.innerHTML = ''; }
    root.hidden = false;
    void root.offsetWidth;
    root.classList.add('is-on');
    d.documentElement.classList.add('ecd-lock');
    var x = root.querySelector('.ecd__x');
    try { x.focus({ preventScroll: true }); } catch (err) {}
    return load();
  }

  function close() {
    if (!root || root.hidden) { return; }
    root.classList.remove('is-on');
    d.documentElement.classList.remove('ecd-lock');
    setTimeout(function () { root.hidden = true; }, 260);
    if (lastFocus && lastFocus.focus && d.contains(lastFocus)) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  /* ---------- Acheter maintenant ---------- */
  function codTrigger(scope) {
    var els = [].slice.call((scope || d).querySelectorAll(COD_SEL));
    return els.filter(function (b) { return b.offsetParent !== null || b.getClientRects().length; })[0] || null;
  }
  /* « Acheter maintenant » : le formulaire EasySell s'ouvre sur la page actuelle (assets/ec-cod.js) */
  var FRAME = /[?&]ec_frame=1/.test(location.search) && W.top !== W;
  function buyNow(variant, qty, productUrl) {
    qty = Math.max(1, Number(qty) || 1);
    var id = variant && (variant.id || variant);
    if (!id) { return; }
    var u = (productUrl || '').split('?')[0];
    if (W.__ecCodApp && u) {
      if (root && !root.hidden) { close(); }
      if (W.ECCod) { W.ECCod.open(u, id, qty); return; }
      location.href = u + '?variant=' + id + '&quantity=' + qty + '&ec_cod=1'; return;
    }
    /* appli de commande non installée : paiement Shopify pour cet article seul (le panier n'est pas modifié) */
    location.href = ROOT + 'cart/' + id + ':' + qty;
  }

  /* fiche produit ouverte directement avec ?ec_cod=1 (lien de repli) : ouvre le formulaire COD dès qu'il est prêt */
  function autoCod() {
    if (FRAME || !W.__ecCodApp || !/[?&]ec_cod=1/.test(location.search)) { return; }
    function go() {
      var tries = 0, t = setInterval(function () {
        var b = codTrigger(d);
        if (b || ++tries > 40) { clearInterval(t); if (b) { b.click(); } }
      }, 150);
    }
    if (d.readyState === 'complete') { setTimeout(go, 700); } else { W.addEventListener('load', function () { setTimeout(go, 700); }); }
  }

  /* ---------- branchements ---------- */
  function hijackAdded() {
    /* l'ancienne confirmation « Voir mon panier » laisse place au panier latéral */
    if (!W.MutationObserver) { return; }
    new MutationObserver(function () {
      var box = d.querySelector('.ec-add.is-on');
      if (box) { box.classList.remove('is-on'); box.hidden = true; open(true); }
    }).observe(d.body, { subtree: true, attributes: true, attributeFilter: ['class'], childList: true });
  }
  d.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('#header-group a[href$="/cart"],#header-group a[href="' + ROOT + 'cart"],[data-ecd-open]');
    if (!a || /\/cart\/?$/.test(location.pathname) || e.metaKey || e.ctrlKey) { return; }
    e.preventDefault(); e.stopPropagation();
    open(false);
  }, true);

  function boot() {
    W.__ecCodApp = !!(CFG.cod_app || W.__ecCodApp || d.querySelector('script[src*="easysell"],script[src*="easy-order-form"],link[href*="easysell"]'));
    if (FRAME) { return; }
    hijackAdded();
    autoCod();
  }
  if (d.readyState === 'loading') { d.addEventListener('DOMContentLoaded', boot); } else { boot(); }

  W.ECBuy = { open: open, close: close, refresh: load, buyNow: buyNow };
})();